// an input and button
// inputs of password that need to be === 55abre33
// button if(password) route to the admin component of main page admin
// main page need to have crud products with search and  ( order details) (showing Data by graph)(list without pictures and with all categorry code)

import { doc, getDoc } from "firebase/firestore";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../context/store.provider";
import { ROUTES_LINKS } from "../../routes/routes";
import { fireStoreDB } from "../user/GettingData/firebase";

import "./admin.css";

function AdminInput() {
  const [value, setValue] = useState("");
  const [pass, setPass] = useState("");
  const { setIsAuth } = useStore();
  // const location = useLocation();
  const navigate = useNavigate();
  const onInputChange = ({ target: { value } }) => {
    setValue(value);
  };
  const onAdminClick = () => {
    if (value === pass) {
      setIsAuth(true);
      navigate(ROUTES_LINKS.TO_ADMIN_SITE);
    } else {
      setValue("");
    }
  };
  useEffect(() => {
    const getPassword = async () => {
      const id = process.env.REACT_APP_MANAGER_PASS;
      const passDoc = doc(fireStoreDB, `store-colbo-Efrat`, id);
      const pass = await getDoc(passDoc);
      setPass(pass.data().password);
    };
    getPassword();
  }, []);

  return (
    <div className="adminEntry">
      <input
        placeholder="manager"
        onChange={onInputChange}
        type="password"
        value={value}
      />
      <button onClick={onAdminClick}>
        <i className="fa-solid fa-lock"></i>
      </button>
    </div>
  );
}

export default AdminInput;
